// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_36wQ1pzkE8dqBDOMyXvc7w","footer":"_1vBtdbLRQNPTTQF0krQ2X3"};